import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatIconModule} from '@angular/material/icon';
import {LetModule, PushModule} from '@ngrx/component';
import {EarlyAdopterModalModule} from '../../common/early-adopter-modal/early-adopter-modal.module';
import {StoragePipeModule} from '../../common/storage.pipe.module';
import {PricingSmallComponent} from './pricing-small.component';

@NgModule({
  declarations: [PricingSmallComponent],
  exports: [PricingSmallComponent],
  imports: [
    CommonModule,
    StoragePipeModule,
    EarlyAdopterModalModule,
    MatButtonModule,
    MatIconModule,
    LetModule,
    PushModule
  ]
})
export class PricingSmallModule {}
